<template>
    <main>
        <!-- <div class="banner">
            <div class="text">
                <h3>专业品质</h3>
                <h5>Professional quality, leading in India</h5>
                <h2>成就印界翘楚</h2>
            </div>
        </div> -->
        <slide-show :data="$root.banners" :ratio="'0.21'"></slide-show>

        <div class="list">
            <router-link :to="'/news/newsDetail/' + i.id" v-for="(i, index) in list" :key="i.id">
                <img :src="i.newPhone">
                <div class="context">
                    <div class="new-title">{{ i.newTitle }}</div>
                    <!-- <div class="new-title1">太和物联与粉丝魔方正式达成战略合作协议，携手打造独特创新的O2O精准营销模式，太和物联与粉丝魔方正式达成战略合作协议，携手打造独特创新的O2O精准营销模式，携手打造独特创新的O2O精准营销模式，太和物联与粉丝魔方正式达成战略合作协议，携手打造独特创新的O2O精准营销模式，携手打造独特创新的O2O精准营销模式，太和物联与粉丝魔方正式达成战略合作协议，携手打造独特创新的O2O精准营销模式</div> -->
                    <div class="new-title1" v-html="i.remark"></div>
                    <div class="new-more">
                        <div class="time">{{ i.issueDate | getTime }}</div>
                        <div class="more">查看更多>></div>
                    </div>
                </div>
                <div class="bor" v-if="index != list.length - 1"></div>
            </router-link>
        </div>
        <pager :xpages="pages" :xcurrent-page="pageNum" @pager="pageNum = $event"></pager>
    </main>
</template>
<style lang="less" scoped>
main {
    .banner {
        background: url(../assets/images/news/banner.jpg) center/cover no-repeat;
        height: 500px;
        display: flex;
        align-items: center;
        position: relative;

        .text {
            position: relative;
            text-align: left;
            color: #FEFEFE;
            padding-left: 456px;

            h3 {
                font-size: 71px;
                line-height: 71px;
                font-weight: 400;
                margin: 0;
            }

            h5 {
                font-size: 24px;
                font-weight: 400;
                margin: 16px 0;
            }

            h2 {
                font-size: 96px;
                line-height: 96px;
                font-weight: 400;
                margin: 0;
            }

            .corner {
                position: absolute;
                border: 2px solid transparent;
                width: 42px;
                height: 42px;

                &.lt {
                    left: 0;
                    top: 0;
                    border-left-color: white;
                    border-top-color: white;
                }

                &.rt {
                    right: 0;
                    top: 0;
                    border-right-color: white;
                    border-top-color: white;
                }

                &.rb {
                    right: 0;
                    bottom: 0;
                    border-right-color: white;
                    border-bottom-color: white;
                }

                &.lb {
                    left: 0;
                    bottom: 0;
                    border-left-color: white;
                    border-bottom-color: white;
                }
            }
        }
    }
}

.list {
    width: 1200px;
    margin: 0 auto;
    background-color: #FFFFFF;
    // min-height: 102px;
    position: relative;
    top: -40px;
    padding: 40px;

    a {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        position: relative;
        margin-bottom: 40px;

        img {
            width: 300px;
            height: 180px;
            object-fit: cover;
        }

        .context {
            padding: 0 20px;
            width: 827px;
        }

        .new-title {
            color: #393939;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 25em;
        }

        .new-title1 {
            color: #7F7F7F;
            margin: 13px 0 49px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .new-more {
            display: flex;
            justify-content: space-between;

            .time {
                color: #7F7F7F;
            }

            .more {
                color: #E50012;
            }
        }

        .bor {
            width: 800px;
            height: 0px;
            border-bottom: 1px solid #D1D1D1;
            position: absolute;
            right: 0;
            bottom: -20px;
        }
    }


}

.pager {
    justify-content: center;
}

@media screen and (max-width: 1360px) {
    // styles for mobile

    .list {
        width: 100%;
        top: -10%;
        padding: 15px;

        a {
            img {
                width: 160px;
                height: 120px;
            }

            .context {
                width: auto;
                overflow: hidden;


                .new-title {
                    width: auto !important;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }

    /deep/ .pager {
        .jump {
            display: none !important;
        }
    }
}
</style>

<script>
export default {
    data() {
        return {
            list: []
        }
    },
    methods: {
        getList() {
            var that = this;
            that.$root.loading = true;
            that.list = [];
            ajax.call(this, {
                url: "/bloc/news/list/bloc",
                data: {
                    pageSize: 4
                },
                s(res) {
                    // res.data.forEach((v) => {
                    //     v.newsContext = $("<div>" + v.newsContext + "</div>")[0].textContent;
                    // });
                    that.$root.loading = false
                    that.list = res.data;
                }
            });
        }
    },
    mounted() {
        this.getList();
        if (this.$root.groupId) {
            this.$root.getBanner(6);
        }
    },
    filters: {
        getTime(value) {
            return value && value.slice(0, 10);
        }
    },
    watch: {
        "$root.language"() {
            this.getList();
        },

    }
}
</script>